import { Outlet } from "react-router-dom";
import { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";

const Layout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-white">
      {/* Header */}
      <Header />

      <div className="flex flex-1">
        {/* Sidebar */}
        <Sidebar 
          collapsed={sidebarCollapsed} 
          onToggleCollapse={toggleSidebarCollapse}
        />
        {/* Main Content */}
        <main
          className={`flex-1 p-6 transition-all duration-300 bg-[#dfdfdf] dark:bg-gray-900 ${
            sidebarCollapsed ? 'ml-0' : ''
          }`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
